import {
  CampaignTriggerType,
  CampaignTriggerTypeEnum,
  Channel,
  ChannelEnum,
  ChannelTriggersMap,
  Flow,
} from "schema"

type SupportedChannel = keyof typeof ChannelTriggersMap

// Webhook is inbound only on Api channel; outbound on Whatsapp/Gmail.
const CHANNEL_FLOW_TRIGGERS: Record<
  SupportedChannel,
  Record<Flow, ReadonlySet<CampaignTriggerType>>
> = {
  [ChannelEnum.Whatsapp]: {
    Inbound: new Set<CampaignTriggerType>([
      CampaignTriggerTypeEnum.WhatsappDefault,
      CampaignTriggerTypeEnum.QR,
      CampaignTriggerTypeEnum.Link,
      CampaignTriggerTypeEnum.Widget,
    ]),
    Outbound: new Set<CampaignTriggerType>([
      CampaignTriggerTypeEnum.Manual,
      CampaignTriggerTypeEnum.Webhook,
      CampaignTriggerTypeEnum.Shopify,
      CampaignTriggerTypeEnum.BigBlue,
    ]),
  },
  [ChannelEnum.Web]: {
    Inbound: new Set<CampaignTriggerType>([
      CampaignTriggerTypeEnum.QR,
      CampaignTriggerTypeEnum.Link,
      CampaignTriggerTypeEnum.Widget,
    ]),
    Outbound: new Set<CampaignTriggerType>(),
  },
  [ChannelEnum.Instagram]: {
    Inbound: new Set<CampaignTriggerType>([CampaignTriggerTypeEnum.InstagramDirectMessage]),
    Outbound: new Set<CampaignTriggerType>([CampaignTriggerTypeEnum.InstagramCommentReply]),
  },
  [ChannelEnum.Gmail]: {
    Inbound: new Set<CampaignTriggerType>([CampaignTriggerTypeEnum.EmailInbox]),
    Outbound: new Set<CampaignTriggerType>([
      CampaignTriggerTypeEnum.Manual,
      CampaignTriggerTypeEnum.Webhook,
      CampaignTriggerTypeEnum.Shopify,
      CampaignTriggerTypeEnum.BigBlue,
    ]),
  },
  [ChannelEnum.Outlook]: {
    Inbound: new Set<CampaignTriggerType>([CampaignTriggerTypeEnum.EmailInbox]),
    Outbound: new Set<CampaignTriggerType>([
      CampaignTriggerTypeEnum.Manual,
      CampaignTriggerTypeEnum.Webhook,
      CampaignTriggerTypeEnum.Shopify,
      CampaignTriggerTypeEnum.BigBlue,
    ]),
  },
  [ChannelEnum.Api]: {
    Inbound: new Set<CampaignTriggerType>([CampaignTriggerTypeEnum.Webhook]),
    Outbound: new Set<CampaignTriggerType>(),
  },
}

export function isSupportedChannel(
  channel: Channel | undefined | null,
): channel is SupportedChannel {
  return channel != null && channel in ChannelTriggersMap
}

export function getCompatibleTriggers(
  channel: Channel | undefined | null,
  flow: Flow | undefined | null,
) {
  if (!isSupportedChannel(channel)) return []

  if (!flow) return ChannelTriggersMap[channel]

  const allowed = CHANNEL_FLOW_TRIGGERS?.[channel]?.[flow]

  if (!allowed) return []

  return ChannelTriggersMap[channel].filter((tr) => allowed.has(tr))
}
